/* istanbul ignore next */
export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded and cannot be loaded twice.`);
  }
}
